import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import InstructionLink, { IIntroductionLinkProps } from '../instruction-link';
import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    instructionListHeaderText: {
      fontSize: '1.7em',
      fontWeight: 'bolder',
      paddingBottom: theme.spacing(1),
    },
    instructionListHeaderTextContainer: {
      height: '3.4em',
    },
  }),
);

export interface IIntroductionListProps {
  name: string;
  links: IIntroductionLinkProps[];
}

export default function InstructionList(props: IIntroductionListProps) {
  const classes = useStyles(baseTheme);
  const { name, links } = props;
  const nameString = name ? `${name}:` : '';
  return (
    <Grid item container xs={12}>
      <div className={classes.instructionListHeaderTextContainer}>
        <Typography color="primary" className={classes.instructionListHeaderText}>
          {nameString} &nbsp;
        </Typography>
      </div>
      <Grid item container xs={12}>
        {links.map((link: IIntroductionLinkProps) =>
          <InstructionLink
            key={`instruction-link-${link.name}`}
            name={link.name}
            pdfUrl={link.pdfUrl}
            videoUrl={link.videoUrl}
            breakpoint={link.breakpoint}
          />)}
      </Grid>
    </Grid>
  );
}
